import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el PILATES 360 después de comprar?',
  a: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos tenés todos los tomos y bonos en tu dispositivo. Sin esperas.'
}, {
  q: '¿Sirve para instructoras con poca experiencia o solo para las avanzadas?',
  a: 'Para todas. El Tomo I empieza desde las bases más clásicas del método y el Tomo VI llega al repertorio avanzado completo. Vos empezás desde donde estás y progresás a tu ritmo.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'El material viene en PDF. Podés leerlo, imprimirlo y usarlo libremente en tus clases. No está diseñado para edición pero podés agregar notas propias.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos están incluidos en las dos opciones sin costo adicional. La diferencia entre las ofertas es el Safe Pilates Pro™ que viene en la opción más elegida.'
}, {
  q: '¿Sirve si doy clases individuales o solo para grupos?',
  a: 'Para ambas modalidades. Cada clase incluye variaciones en 3 niveles que permiten adaptarla a una alumna individual o a un grupo heterogéneo sin modificar la estructura.'
}, {
  q: '¿Sirve si tengo alumnas de distintos niveles al mismo tiempo?',
  a: 'Exactamente para eso está diseñado el Bono 3 — Guía de Variaciones en 3 Niveles. Presentás el ejercicio en 3 versiones simultáneas y cada alumna trabaja al máximo de su capacidad actual.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de Pilates?',
  a: 'La mayoría del material disponible son listas de ejercicios o fichas sueltas. PILATES 360 es un sistema anual completo: 6 tomos temáticos con progresión lógica, cueings listos, variaciones por nivel y un calendario que organiza los 12 meses. No hay nada igual en el mercado argentino.'
}, {
  q: '¿Por qué elegir el PILATES 360 + Safe Pilates Pro y no el estándar?',
  a: 'Si alguna de tus alumnas tiene o puede tener una condición especial (hernia, prótesis, embarazo, osteoporosis, problemas de hombro), el Safe Pilates Pro es indispensable. Te da la seguridad legal y técnica que el sistema estándar no puede darte solo.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas. Podés verificarlo en Mercado Pago.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 md:py-16 bg-offwhite" data-id="element-78">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-79">
        <div className="text-center mb-16" data-id="element-80">
          <h2 className="text-3xl md:text-5xl font-bold text-charcoal font-playfair mb-4" data-id="element-81">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-82">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm" data-id="element-83">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-84">
                <span className="font-bold text-charcoal pr-8" data-id="element-85">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-sage flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-86" />
              </button>
              <AnimatePresence data-id="element-87">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-88">
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-100 pt-4" data-id="element-89">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};